"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlArtifactFrame = void 0;
exports.htmlArtifactDocument = htmlArtifactDocument;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SCRIPTS_IN_OPAQUE_ORIGIN = "allow-scripts";
var HTML_ARTIFACT_CONTENT_SECURITY_POLICY = ["default-src 'none'", "script-src 'unsafe-inline' 'unsafe-eval' https://cdnjs.cloudflare.com https://cdn.jsdelivr.net/npm/ https://unpkg.com https://cdn.tailwindcss.com https://code.jquery.com", "style-src 'unsafe-inline' https://fonts.googleapis.com", "font-src https://fonts.gstatic.com", "img-src data: blob:"].join("; ");
var FILL_WRAPPER_STYLE = "html,body,iframe{margin:0;width:100%;height:100%;border:0;display:block}";
function escapeAttribute(value) {
  return value.replaceAll("&", "&amp;").replaceAll('"', "&quot;");
}
function htmlArtifactDocument(html) {
  return ["<!doctype html>", "<meta http-equiv=\"Content-Security-Policy\" content=\"".concat(HTML_ARTIFACT_CONTENT_SECURITY_POLICY, "\">"), "<style>".concat(FILL_WRAPPER_STYLE, "</style>"), "<iframe sandbox=\"".concat(SCRIPTS_IN_OPAQUE_ORIGIN, "\" srcdoc=\"").concat(escapeAttribute(html), "\"></iframe>")].join("");
}
var HtmlArtifactFrame = exports.HtmlArtifactFrame = function HtmlArtifactFrame(_ref) {
  var title = _ref.title,
    html = _ref.html,
    className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
    title: title,
    srcDoc: htmlArtifactDocument(html),
    sandbox: SCRIPTS_IN_OPAQUE_ORIGIN,
    className: className,
    "data-sentry-component": "HtmlArtifactFrame",
    "data-sentry-source-file": "HtmlArtifactFrame.tsx"
  });
};